<template>
  <SDataTable :headers="headers" :items="sensors">
    <template v-slot:item.macAddress="{ item }">
      <div class="font-weight-bold">{{ item.macAddress }}</div>
    </template>

    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | dateFilter }}
    </template>

    <template v-slot:item.place="{ item }">
      {{ item.place == "" ? "-" : item.place }}
    </template>

    <template v-slot:item.connectionType="{ item }">
      <div class="d-flex justify-start align-center font-weight-bold">
        <v-img
          :src="item.connectionType == 'BLE' ? ble : lora"
          max-width="50"
        ></v-img>
        <div class="ml-1">-</div>
        <div class="ml-1">
          {{ item.connectionType == "BLE" ? "BLE" : "LoRa" }}
        </div>
      </div>
    </template>

    <template v-slot:item.provider="{ item }">
      <div class="d-flex justify-center">
        <v-img
          v-if="item.provider == 'ORANGE'"
          :src="orangeProvider"
          max-width="35"
        >
        </v-img>
        <v-img
          v-else-if="item.provider == 'OBJENIOUS'"
          :src="objeniousProvider"
          max-width="70"
        >
        </v-img>
        <v-img v-else :src="clientProvider" max-width="50"></v-img>
      </div>
    </template>

    <template v-if="user.userType == 'ADMIN'" v-slot:item.owner="{ item }">
      <div v-if="item.owner">
        <SButton
          @click="viewOwner(item)"
          small
          color="primaryColor"
          icon="fa-user-tie"
        >
          Propriétaire
        </SButton>
      </div>
      <v-chip
        v-else
        small
        class="text-sm-overline"
        color="red"
        text-color="white"
      >
        Indisponible
      </v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="d-flex justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <SButton
                small
                color="primaryColor"
                icon="fa-eye"
                @click="viewOne(item)"
              ></SButton>
            </div>
          </template>
          <span>Voir</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <SButton
                small
                color="warning"
                icon="fa-edit"
                @click="editOne(item)"
              ></SButton>
            </div>
          </template>
          <span>Modifier</span>
        </v-tooltip>
      </div>
    </template>
  </SDataTable>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ble from "@/assets/icons/ble.gif";
import lora from "@/assets/icons/lorawan.gif";
import orangeProvider from "@/assets/icons/orange.png";
import objeniousProvider from "@/assets/icons/objenious.png";
import clientProvider from "@/assets/icons/client.gif";
import dateFilter from "@filters/dateFilter";

export default {
  name: "SensorsTable",
  data: () => ({
    ble,
    lora,
    orangeProvider,
    objeniousProvider,
    clientProvider,
    headers: [
      { text: "Adresse Mac", value: "macAddress", align: "center" },
      { text: "Nom capteur", value: "nickname", align: "center" },
      { text: "Endroit", value: "place", align: "center" },
      { text: "Mode", value: "connectionType", align: "center" },
      { text: "Fournisseur", value: "provider", align: "center" },
      { text: "Date d'ajout", value: "createdAt", align: "center" },
      { text: "Propriétaire", value: "owner", align: "center" },
      { text: "Actions", value: "actions", align: "center" },
    ],
    sensors: [],
  }),
  methods: {
    editOne(sensor) {
      return this.$emit("askUpdate", sensor);
    },
    viewOne(sensor) {
      return this.$router.push({
        name: "SensorCharts",
        params: { sensorId: sensor.macAddress },
      });
    },
    viewOwner(sensor) {
      return this.$router.push({ name: "User", params: { userId: sensor.owner } });
    },
    ...mapActions({
      retrieveSensors: "sensors/retrieveSensors",
    }),
  },
  computed: {
    ...mapGetters({
      getSensors: "sensors/getSensors",
      user: "auth/getUser",
    }),
  },
  filters: {
    dateFilter,
  },
  async created() {
    try {
      if (this.user.userType != "ADMIN") {
        this.headers = this.headers.filter((header) => header.value != "owner");
      }
      if (this.getSensors.length == 0) {
        await this.retrieveSensors();
      }
      this.sensors = this.getSensors;
    } catch ({ success, error }) {
      this.$emit("onErrors", { success, message: error });
    }
  },
};
</script>

<style></style>
